import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingsService } from 'modules/admin/shared/core/settings.service';
import { Title } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-admin-component',
  templateUrl: './admin-app.component.html',
  styleUrls: ['./admin-app.component.scss', './admin-app-style-handler.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminAppComponent implements OnInit {
  public loading: boolean = true;

  @HostBinding('class.layout-fixed') get isFixed() {
    return this.settings.getLayoutSetting('isFixed');
  }
  @HostBinding('class.aside-collapsed') get isCollapsed() {
    return this.settings.getLayoutSetting('isCollapsed');
  }
  @HostBinding('class.layout-boxed') get isBoxed() {
    return this.settings.getLayoutSetting('isBoxed');
  }
  @HostBinding('class.layout-fs') get useFullLayout() {
    return this.settings.getLayoutSetting('useFullLayout');
  }
  @HostBinding('class.hidden-footer') get hiddenFooter() {
    return this.settings.getLayoutSetting('hiddenFooter');
  }
  @HostBinding('class.layout-h') get horizontal() {
    return this.settings.getLayoutSetting('horizontal');
  }
  @HostBinding('class.aside-float') get isFloat() {
    return this.settings.getLayoutSetting('isFloat');
  }
  @HostBinding('class.offsidebar-open') get offsidebarOpen() {
    return this.settings.getLayoutSetting('offsidebarOpen');
  }
  @HostBinding('class.aside-toggled') get asideToggled() {
    return this.settings.getLayoutSetting('asideToggled');
  }
  @HostBinding('class.aside-collapsed-text') get isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  constructor(public settings: SettingsService, private router: Router, public titleService: Title) {
    console.log('ADMINA PP COMP CONST');
    //  sessionStorage.clear();

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Agilysys Book & Express');
    let link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'assets/favicon.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
    $(document).on('click', '[href="#"]', (e) => e.preventDefault());
    console.log('inside app admin ts');
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
    }
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }
}
